export const scheduleJobPanelStyles = {
  panel: {
    backgroundColor: '#fff',
    borderRadius: 4,
    border: '1px solid #e8ebf1',
    boxShadow: '0px 10px 15px 0px rgba(0,0,0,0.1), 0px 4px 6px 0px rgba(0,0,0,0.1)',
    overflow: 'hidden',
    marginTop: 4
  },
  panelList: {
    maxHeight: 260,
    overflowY: 'auto',
    padding: '16px 0 8px'
  },
  panelFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px 16px',
    borderTop: '1px solid #d9dee8',
    height: 51
  },
  panelClearBtn: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: 600,
    color: '#55647c',
    padding: '0 4px'
  },
  panelDoneBtn: {
    backgroundColor: '#0766ee',
    border: 'none',
    borderRadius: 3,
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: 600,
    color: '#fff',
    padding: '8px 16px',
    '&:hover': {
      backgroundColor: '#0557cc'
    }
  },
  crewTile: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    padding: '5px 8px',
    cursor: 'pointer',
    margin: '0 16px',
    borderRadius: 4,
    '&:hover': {
      backgroundColor: '#f7f8fa'
    }
  },
  crewTileSelected: {
    backgroundColor: '#eef4fd',
    '&:hover': {
      backgroundColor: '#e3ecfb'
    }
  },
  crewTileBar: {
    width: 5,
    minHeight: 32,
    alignSelf: 'stretch',
    borderRadius: 4,
    flexShrink: 0
  },
  crewTileContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  crewTileName: {
    fontSize: 16,
    fontWeight: 400,
    color: '#394860',
    lineHeight: '22px'
  },
  crewTileMembers: {
    fontSize: 12,
    fontWeight: 400,
    color: '#a2afc3',
    lineHeight: 1.4
  }
} as const
